import { sharePointSitesService } from '@/services/sharepoint-sites/sharepoint-sites-service';
import { useQuery } from '@tanstack/vue-query';

export const useProjectSitesQuery = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['sharepoint-sites', 'project-sites'],
    queryFn: () => sharePointSitesService.getProjectSites(),
    enabled,
  });
};
